var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputerGraph2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.55,158.31v15.58M96.28,158.31v15.58M64.62,115.07l20.47-33.5,13,23,16.92-21.53,13.94,17,26.11-33.49M77.37,175.18h63.54M36.21,128.66H182.06m-20.39,28.05H56.61a20.47,20.47,0,0,1-20.4-20.55V69.51A20.48,20.48,0,0,1,56.61,49H166.23a15.89,15.89,0,0,1,15.83,16v71.25A20.46,20.46,0,0,1,161.67,156.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerGraph2);
export default __webpack_public_path__ + "static/media/COMPUTER_GRAPH_2.644d8882458288a45f0e47ff69d419f3.svg";
export { ForwardRef as ReactComponent };